module.exports = __webpack_public_path__ + "departed-today.png?400782fdfa1772d4ad3322c6fe8746a2";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/departed-today.png
// module id = 481
// module chunks = 0